<template lang="pug">
.filtering__facets
  template(v-for="(facet, i) in facets")
    Facet(:options="facet", :depth="i")
</template>


<script>
import Facet from "./Facet.vue";
import { mapGetters } from "vuex";
export default {
  name: "FilteringFacets",
  components: {
    Facet,
  },
  computed: {
    ...mapGetters(["data", "model", "lookup"]),
    facets() {
      let facets = [
        [
          { categoryId: undefined, categoryName: this.data.viewAllText },
          ...this.data.categories,
        ],
      ];
      this.model.forEach((selection) => {
        if (selection === undefined) return;
        let item = this.lookup(selection);
        if (item.hasOwnProperty("children")) {
          console.log(item)
          facets = [
            ...facets,
            [{ categoryId: undefined, categoryName: `All ${item.categoryName}`, categoryWeight: item.categoryWeight }, ...item.children],
          ];
        }
      });
      return facets;
    },
  },
};
</script>

<style lang="scss" scoped>
.filtering__facets {
  display: flex;
  gap: 1rem;
  margin-bottom: 3rem;
  flex-direction: column;
  max-width: 100%;
  @include mq(md) {
    flex-direction: row;
  }
}
</style>